// extracted by mini-css-extract-plugin
module.exports = {"submit":"SubmitButton_submit__1oO1F","isDisabled":"SubmitButton_isDisabled__1Yb4p"};